import { keepPreviousData, useQuery } from '@tanstack/react-query';

import {
  type CafeteriaOverviewFilters,
  type ProductSalesFilters,
  type SalesReportFilters,
  cafeteriaOverviewApi,
  reportsApi,
} from '../reports';

const keys = {
  sales: (filters: SalesReportFilters) =>
    ['cafeteria', 'reports', 'sales', filters.period, filters.from ?? null, filters.to ?? null] as const,
  products: (filters: ProductSalesFilters) =>
    ['cafeteria', 'reports', 'products', filters.from ?? null, filters.to ?? null] as const,
  overview: (filters: CafeteriaOverviewFilters) =>
    [
      'cafeteria',
      'reports',
      'overview',
      filters.preset,
      filters.preset === 'custom' ? (filters.from ?? null) : null,
      filters.preset === 'custom' ? (filters.to ?? null) : null,
    ] as const,
};

// Named distinctly from other cafeteria query hooks (barrel-collision history) — this is the
// admin sales/accounting report, not the per-user wallet or POS hooks.
export function useSalesReportQuery(filters: SalesReportFilters) {
  return useQuery({
    queryKey: keys.sales(filters),
    queryFn: () => reportsApi.sales(filters),
  });
}

export function useProductSalesQuery(filters: ProductSalesFilters = {}) {
  return useQuery({
    queryKey: keys.products(filters),
    queryFn: () => reportsApi.products(filters),
  });
}

/** The whole Reports tab for one range. Switching range keeps the last report on screen while the next loads. */
export function useCafeteriaOverviewQuery(filters: CafeteriaOverviewFilters) {
  return useQuery({
    queryKey: keys.overview(filters),
    queryFn: () => cafeteriaOverviewApi.overview(filters),
    placeholderData: keepPreviousData,
  });
}
